import { render, staticRenderFns } from "./LicenseWriteDefaultLayout.vue?vue&type=template&id=74a79fd4&scoped=true"
import script from "./LicenseWriteDefaultLayout.vue?vue&type=script&lang=js"
export * from "./LicenseWriteDefaultLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a79fd4",
  null
  
)

export default component.exports